module.exports = __webpack_public_path__ + "img/nodeType6.6f259c4f.svg";